<template>
  <vx-card class="mb-base">
    <div class="vx-row">
      <vs-alert color="warning" :active="showAlert" icon-pack="feather" icon="icon-info">
        {{settings.label}}
        <br />
        {{settings.reject_reason}}
      </vs-alert>

      <div class="vx-col w-full flex p-2">
        <template v-for="(val,id) in settings.actionButtons">
          <vs-button
            :color="val.color"
            :key="id"
            :size="val.btnSize"
            icon-pack="feather"
            :icon="val.icon"
            class="mr-4"
            @click="handleSubmit(
              val.endPoint,
              val.confirmationTitle,
              val.confirmationMessage,
              val.payLoad,
              val.getReason,
              val.rejectReasonMessage,
              val.rejectDialogTitle,
              val.successMessage,
              val.sucessEventName,
              val.successEventValue
              )"
          >{{ val.buttonLabel }}</vs-button>
        </template>
      </div>
 
      <vs-prompt
        :title="rejectDialogTitle"
        @cancel="val=''"
        @accept="validateReason"
        :active.sync="showRejectReason"
      >
        <div class="con-exemple-prompt">
          <span>{{ rejectReasonMessage }}</span>
          <vs-input
            v-validate="'required|min:3'"
            placeholder="enter here..."
            vs-placeholder="enter here..."
            v-model="reasonModel"
            class="mt-3 w-full"
          />
        </div>
      </vs-prompt>
      
    </div>
  </vx-card>
</template>
<script>
import { mapGetters } from "vuex";
import { settingsMixin } from "../settingsMixin";
import { alertMixin } from "../../../mixin/alertMixin";
import { axiosMixin } from "../../../mixin/axiosMixin";
import { helperMixin } from "../../../mixin/helperMixin";
export default {
  mixins: [settingsMixin, alertMixin, axiosMixin, helperMixin],
  data() {
    return {
      showAlert: false,
      showRejectReason: false,
      rejectReasonMessage: "",
      reasonModel: "",
      payLoad: {},
      endPoint: "",
      rejectDialogTitle: "",
      successMessage: "",
      sucessEventName: "",
      successEventValue: ""
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo",
      getDataStructureInChunk: "profile/getDataStructureInChunk",
      getMainInfo: "profile/getMainInfo"
    }),
    settings() {
      this.showAlert = true; //we need to trigger this so that the alert will show

      return this.getActionSettings(
        this.$route.params.subject,
        this.$route.params.key
      );
    }
  },
  methods: {
    handleSubmit(
      endPoint,
      title,
      message,
      payLoad,
      getReason,
      rejectReasonMessage,
      rejectDialogTitle,
      successMessage,
      sucessEventName,
      successEventValue
    ) {
      console.log("payLoad:", payLoad);
      this.payLoad = payLoad;
      this.endPoint = endPoint;
      this.successMessage = successMessage;

      this.sucessEventName = sucessEventName;
      this.successEventValue = successEventValue;

      if (getReason) {
        this.showRejectReason = true;
        this.rejectReasonMessage = rejectReasonMessage;
        this.rejectDialogTitle = rejectDialogTitle;
      } else {
        this.confirmAlert(title, message).then(res => {
          this.submitNow();
        });
      }
    },
    validateReason() {
      if (this.reasonModel == "") {
        this.errorAlert("Required", "The Reason field is required");
        this.showRejectReason = true;
      } else {
        this.addToObject(this.payLoad, { rejectReason: this.reasonModel });
        this.submitNow();
      }
    },
    submitNow() {
      this.aronPost(this.endPoint, this.payLoad, "", "")
        .then(response => {
          if (response.data.status == "success") {
            this.normarAlert("Success", this.successMessage).then(res => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue
              });
            });
          } else {
            this.normarAlert(
              "Error",
              "Something Went wrong please try again later"
            ).then(res => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue
              });
            });
          }

          //go back
        })
        .catch(error => {
          console.log("error ActionContainer reason:", error);
        });
    }
  }
};
</script>